// import { format } from "date-fns";
import { getAuth } from 'firebase/auth'

import React, { useEffect, useMemo, useState } from 'react'
import { Check, Minus, Plus, Tag, Trash, UserPlus, X } from 'lucide-react'
import { RotatingLines, TailSpin } from 'react-loader-spinner'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { MatchedDoctor } from '../../types/User'
import { AppState } from '../../state'
import {
	useApplyPromo,
	useOneTimePay,
	useRequestConsultation,
} from '../../state/features/authSlice/hooks'
import {
	useBookWellnessClass,
	useCreateServiceOrderItem,
	useSwitchPage,
	useUpdateCart,
	useVerifyPayment,
} from '../../state/features/applicationSlice/hooks'
import { PromoCode } from '../../types'
import { getInstitutionLocations, getUserData } from '../../functions/firebase'
import { setUser } from '../../state/features/authSlice'
import { BookingSource } from '../../types/Consultation'
import { ResponseStatus } from '../../types/Requests/Status'
import {
	ApplicationPages,
	setActiveBooking,
	setCart,
} from '../../state/features/applicationSlice'
import errorcodes from '../../constants/errorcodes'
import { DDGColors } from '../../constants/colors'
import Image from '../Image'
import { Booking, Location, Service } from '../../types/HealthInstitution'
import {
	addMinutes,
	convertDateToString,
	formatAddress,
	formatCurrency,
	formatNumberScale,
	getInitials,
} from '../../functions'
import SelectInput from '../SelectInput'
import { SubscribeToClassOnDateRequest } from '../../types/Requests/ConsultationRequest'
import { Input } from '@headlessui/react'
import CountryDropdown from '../CountryDropdown'

const ClassStepBooking: React.FC = () => {
	const { User, Account, PaymentMethods } = useSelector<
		AppState,
		AppState['auth']
	>((state) => state.auth)
	console.log('User', User, Account)
	const { cart, activeFacility } = useSelector<
		AppState,
		AppState['application']
	>((state) => state.application)
	const [applying, setApplying] = useState(false)
	const applyPromo = useApplyPromo()
	const [classCount, setClassCount] = useState(1)
	const [promoCodeData, setPromoCodeData] = useState<PromoCode | null>()
	const [promoCode, setPromoCode] = useState<string>()
	const urlParams = new URLSearchParams(window.location.search)
	const trxref = urlParams.get('trxref')
	const qty = urlParams.get('qty')
	const [selectedMethod, setSelectedMethod] = useState('WALLET')
	const [walletId, setWalletId] = useState('DEFAULT')
	const router = useSwitchPage()
	const pay = useOneTimePay()
	const verifyPayment = useVerifyPayment()
	const orderFunc = useBookWellnessClass()
	const [loading, setLoading] = useState(false)
	const [paying, setPaying] = useState(false)
	const [verifying, setVerifying] = useState(false)

	const [toggleGuests, setToggleGuests] = useState(false)
	const [guests, setGuests] = useState<SubscribeToClassOnDateRequest['guests']>([])

	const [includeSelfToGuestOrder, setIncludeSelfToGuestOrder] = useState(true)

	const [payReference, setPayReference] = useState('')
	const { activeClass: wellnessClass, activeClassBooking } = useSelector<
		AppState,
		AppState['application']
	>((state) => state.application)

	const continueFunc = async () => {
		if (!guests.every(obj =>
			Object.values(obj).every(Boolean)
		)) return toast.warning('Fill all guest details')
		setLoading(true)
		console.log('activeFacility', activeFacility)
		orderFunc(
			{
				uid: User?.accountId!,
				userMemberId: User?.memberID!,
				classHourId: activeClassBooking?.classHourId!,
				classId: wellnessClass?.id!,
				// name: User?.firstName + ' ' + User?.lastName,
				facilityId: activeFacility?.id!,
				// email: User?.email!,
				quantity: classCount,
				promoCodeId: promoCodeData?.id ?? '',
				date: activeClassBooking?.date ?? new Date() as any,
				walletId,
				guests: guests.map(item => ({name: item.name, phoneNumber: item.phoneNumber })),
				canUseLoan: false,
				isGift: !includeSelfToGuestOrder,
				bookingSource: BookingSource.BOOKING_PAGE
			},
			async ({ status, code, message, data }: any) => {
				if (status === ResponseStatus.SUCCESS) {
					setLoading(false)
					urlParams.set('id', data.subscriptions[0].id)
					window.history.pushState(null, '', '?' + urlParams.toString())
					toast.success('Class successfully booked')
					router(ApplicationPages.BOOKING_CLASS_SUCCESS)
				}
				if (code === errorcodes.insuficientCredits) {
					setPaying(true)
					// call pay func
					pay(
						{
							amount: (100 * data.data.amount + 1).toFixed(2),
							email: User?.email,
							patientId: User?.accountId,
						},
						(ref: string) => {
							setPayReference(ref)
						}
					)
				} else if (status === ResponseStatus.ERROR) {
					setLoading(false)
				}
			}
		)
	}

	const verifyTransaction = async (txref: string) => {
		setVerifying(true)
		const paid = await verifyPayment(txref)
		console.log('paid', paid)
		if (paid) {
			setSelectedMethod('WALLET')
			continueFunc()
		} else {
			setLoading(false)
			toast.error('Unable to verify payment')
		}
		urlParams.delete('trxref')
		setPaying(false)
		setVerifying(false)
	}
	useEffect(() => {
		if (trxref && !verifying) {
			console.log('trxref', trxref)
			verifyTransaction(trxref as string)
		}
	}, [trxref])
		useEffect(() => {
		if (qty) {
			setClassCount(Number(qty))
		}
	}, [qty])
	const discountAmount = useMemo(() => {
		return wellnessClass?.bookingDiscount?.message &&
			wellnessClass.bookingDiscount?.percentage > 0 &&
			classCount >= wellnessClass.bookingDiscount?.quantityTrigger
			? (wellnessClass.bookingDiscount?.percentage / 100) *
					(classCount * wellnessClass.price)
			: 0
	}, [classCount])

	console.log(guests)

	const handleSetGuests = (index: number, newData: Partial<SubscribeToClassOnDateRequest['guests'][number]>) => {
		setGuests((prevItems) => {
			const updatedItems = [...prevItems]
			updatedItems[index] = {
				...updatedItems[index],
				...newData,
			}

			return updatedItems
		})
	}

	if (!Account || !wellnessClass) {
		return <></>
	}
	console.log('promoCodeData', promoCodeData)
	return (
		<div className='flex flex-col flex-1 overflow-y-scroll scroll'>
			{wellnessClass?.bookingDiscount?.message &&
				wellnessClass?.bookingDiscount?.percentage > 0 && (
					<div className='py-3 text-xs font-semibold text-center text-white bg-primary'>
						{wellnessClass?.bookingDiscount.message}
					</div>
				)}
			<div className='flex border-[#EEEEEE] px-4 py-4'>
				<div className='flex-1'>
					<h2 className='mb-2 text-xs font-bold'>Instructor</h2>
					{wellnessClass.instructor ? (
						<div className='flex flex-row items-center space-x-2'>
							<div className='relative self-start w-6 h-6 '>
								<Image
									className='object-cover w-full h-full text-white text-[10px] flex items-center justify-center rounded-full bg-primary'
									src={
										[...(activeFacility?.classInstructors ?? [])].find(
											(instructor) => instructor.id === wellnessClass.instructor
										)?.image ?? ''
									}
									alt={'--'}
									useBase={false}
								/>
							</div>
							<p className='text-xs text-[#3A3A3A]'>
								{wellnessClass?.instructor
									? [...(activeFacility?.classInstructors ?? [])].find(
											(instructor) => instructor.id === wellnessClass.instructor
									  )?.name
									: '--'}
							</p>
						</div>
					) : (
						<p>--</p>
					)}
				</div>
				<div className='flex-1'>
					<h2 className='mb-2 text-xs font-bold'>Capacity</h2>
					<p className='text-xs text-[#3A3A3A]'>
						{wellnessClass?.capacity ?? 10} Participants
					</p>
				</div>
			</div>
			<div className='flex border-[#EEEEEE] border-t px-4 py-4 flex-row items-center'>
				<div className='flex-1 '>
					<h2 className='mb-2 text-xs font-bold'>{wellnessClass.title}</h2>
					<p className='text-xs text-[#3A3A3A]'>
						{60} mins of {wellnessClass.category}
					</p>
				</div>
				<div className='flex flex-row items-center justify-between space-x-4 rounded-full '>
					<button
						disabled={classCount === 1}
						onClick={() => {
							urlParams.set('qty', (classCount - 1).toString())
							window.history.pushState(null, '', '?' + urlParams.toString())
							setClassCount(classCount - 1)
						}}
						className={`w-8 h-8  border  rounded-full flex items-center justify-center ${
							classCount <= 1 ? 'border-[#DBDBDB]' : 'border-dark'
						}`}
					>
						<Minus
							size={16}
							color={classCount <= 1 ? '#9D9D9D' : DDGColors.dark}
						/>
					</button>
					<p className='mx-2 text-xs font-bold'>{classCount}</p>
					<button
						disabled={classCount === 4}
						onClick={() => {
							urlParams.set('qty', (classCount + 1).toString())
							window.history.pushState(null, '', '?' + urlParams.toString())
							setClassCount(classCount + 1)
						}}
						className={`w-8 h-8 rounded-full border flex items-center justify-center border-dark`}
					>
						<Plus size={16} color={DDGColors.dark} />
					</button>
				</div>
			</div>

			<div className='px-4 border-[#EEEEEE] border-t  py-4'>
				<h2 className='mb-4 text-xs font-bold'>Class Details</h2>
				<div className='space-y-2 text-xs'>
					<div className='flex items-center justify-between'>
						<div className='text-[#3A3A3A]'>Time</div>
						<div className='text-[#8C8C8C]'>9:14 PM</div>
					</div>
					<div className='flex items-center justify-between'>
						<div className='text-[#3A3A3A]'>Date</div>
						<div className='text-[#8C8C8C]'>Friday, 6th Jan 2025</div>
					</div>
					<div className='flex items-center justify-between'>
						<div className='text-[#3A3A3A]'>Location</div>
						<div className='text-[#8C8C8C] text-right'>
							{formatAddress(activeFacility?.details.address!, false, true)}
						</div>
					</div>
					<div className='flex items-center justify-between'>
						<div className='text-[#3A3A3A]'>Your Email</div>
						<div className='text-[#8C8C8C] text-right'>
							{/* <span className='pr-2 font-semibold text-primary'>Edit</span> */}
							{User?.email}
						</div>
					</div>
				</div>
			</div>
			<div className='px-4 border-[#EEEEEE] border-t py-4 '>
				<div className='space-y-2 text-xs'>
					<div className='flex items-center justify-between'>
						<div className='text-[#3A3A3A]'>Class Price</div>
						<div className='text-[#8C8C8C]'>
							{wellnessClass.isFree ? 'FREE':formatCurrency(wellnessClass.price)}
						</div>
					</div>
					{discountAmount > 0 && <div className='flex items-center justify-between'>
						<div className='text-[#3A3A3A]'>Discount</div>
						<div className='text-[#8C8C8C]'>
							- {formatCurrency(discountAmount)}
						</div>
					</div>}
					{promoCodeData?.id && (
						<div className='flex items-center justify-between font-semibold text-primary '>
							<div className=''>Discount via Promo Code</div>
							<div className='text-right '>
								{formatCurrency(
									(classCount *
										wellnessClass.price *
										promoCodeData.value) 
								)}
							</div>
						</div>
					)}
					<div className='flex items-center justify-between'>
						<div className='font-semibold text-dark'>Total Due</div>
						<div className='font-semibold text-right text-dark'>
							{wellnessClass.isFree? 0 :formatCurrency(
								classCount * wellnessClass.price -
									discountAmount -
									classCount *
										wellnessClass.price *
										(promoCodeData
											? promoCodeData?.value
											: 0) +
									1
							)}
							{guests.length > 0 && <span className='text-base '>{'  '}{includeSelfToGuestOrder ? `x${guests.length + 1}` : `x${guests.length}`}</span>}
						</div>
					</div>
				</div>
			</div>
			<div className='flex flex-row items-center px-4 border-[#EEEEEE] border-t'>
				<div className='flex items-center justify-center w-10 h-10 mr-4 rounded-full '>
					<Tag name='price-tag' size={22} color='#034a47' />
				</div>
				<div className='flex flex-row items-center justify-between flex-1 py-4 '>
					<div className='self-stretch justify-center '>
						<input
							autoComplete='off'
							value={promoCode}
							placeholder='Got a promo code ?'
							onChange={(text) => setPromoCode(text.target.value)}
							disabled={Boolean(promoCodeData)}
							className='text-sm font-bold outline-none'
						/>
						{promoCodeData && (
							<p className='text-xs'>{promoCodeData.description}</p>
						)}
					</div>
					{promoCode && promoCode.length >= 4 && (
						<button
							onClick={() => {
								if (!promoCodeData) {
									setApplying(true)
									applyPromo(promoCode.trim(), async (val: any) => {
										setApplying(false)
										if (val.status === 'FAILED') {
											toast.error(val.message)
										} else {
											toast.success(val.message)
										}

										if (val.promoCodeData) {
											setPromoCodeData(val.promoCodeData)
										}
										if (val.status !== 'FAILED') {
											console.log('failed')
										}
									})
								} else {
									setPromoCodeData(null)
								}
							}}
							className='cursor-pointer'
							disabled={
								promoCodeData ? false : !promoCode || applying || loading
							}
						>
							{promoCodeData ? (
								<div className='p-4 rounded-full'>
									<Trash color={DDGColors.blood} size={14} />
								</div>
							) : applying ? (
								<TailSpin width={20} height={20} color={DDGColors.primary} />
							) : (
								<p
									className={`${
										promoCode ? 'text-primary' : 'text-dark'
									} text-sm font-bold`}
								>
									Apply
								</p>
							)}
						</button>
					)}
				</div>
			</div>
			<div className=' px-4 pb-40 border-[#EEEEEE] border-t pt-4'>
				<p className='text-xs font-semibold text-gray700'>Payment method</p>
				<div className='relative flex flex-col mt-4 space-y-4'>
					<button
						onClick={() => {
							setSelectedMethod('WALLET')
						}}
						className='flex flex-row items-center w-full space-x-3 '
					>
						<div
							className={`self-start flex items-center justify-center w-5 h-5 rounded-full ${
								selectedMethod === 'WALLET'
									? 'bg-primary'
									: 'border-2 border-gray-300 cursor-pointer'
							}`}
						>
							{selectedMethod === 'WALLET' ? (
								<Check size={12} color={DDGColors.primaryLight} />
							) : (
								<></>
							)}
						</div>
						<div className='flex-row  flex items-center justify-between flex-1  border-opacity-40 border-b pb-3 border-[#D6D6D6]'>
							<div className='flex flex-col items-start flex-1 '>
								<p className='font-semibold text-gray900 text-xs mb-0.5'>
									DDG Balance
								</p>
								<p className='text-[11px] text-gray500'>
									₵
									{(
										Account.balance.value + (Account.balance?.org_value ?? 0)
									).toFixed(2)}
								</p>
							</div>
							<div className='items-center flex justify-center rounded-full p-1.5 bg-primaryLight'>
								<Image
									useBase
									alt='wallet'
									src={'/img/empty-wallet.svg'}
									width={16}
									height={16}
								/>
							</div>
						</div>
					</button>
					<button
						onClick={() => {
							setSelectedMethod('mobile_money')
						}}
						className='flex flex-row items-center w-full space-x-3 '
					>
						<div
							className={`self-start flex items-center justify-center w-5 h-5 rounded-full ${
								selectedMethod === 'mobile_money'
									? 'bg-primary'
									: 'border-2 border-gray-300 cursor-pointer'
							}`}
						>
							{selectedMethod === 'mobile_money' ? (
								<Check size={12} color={DDGColors.primaryLight} />
							) : (
								<></>
							)}
						</div>
						<div className='flex-row  flex items-center justify-between flex-1  border-opacity-40 border-b pb-3 border-[#D6D6D6]'>
							<div className='flex flex-col items-start flex-1 '>
								<p className='text-xs font-semibold text-gray900 '>
									Mobile Money
								</p>
							</div>
							<div className=''>
								<Image
									useBase
									width={100}
									height={20}
									alt='wallet'
									src={'/img/momo.svg'}
									className='object-contain'
								/>
							</div>
						</div>
					</button>
					<button
						onClick={() => {
							setSelectedMethod('CARD')
						}}
						className='flex flex-row items-center w-full space-x-3 '
					>
						<div
							className={`self-start flex items-center justify-center w-5 h-5 rounded-full ${
								selectedMethod === 'CARD'
									? 'bg-primary'
									: 'border-2 border-gray-300 cursor-pointer'
							}`}
						>
							{selectedMethod === 'CARD' ? (
								<Check size={12} color={DDGColors.primaryLight} />
							) : (
								<></>
							)}
						</div>
						<div className='flex-row  flex items-center justify-between flex-1  border-opacity-40 border-b pb-3 border-[#D6D6D6]'>
							<div className='flex flex-col items-start flex-1 '>
								<p className='text-xs font-semibold text-gray900 '>Bank Card</p>
							</div>
							<div className=''>
								<Image
									useBase
									width={50}
									height={20}
									alt='wallet'
									src={'/img/cards.png'}
									className='object-contain'
								/>
							</div>
						</div>
					</button>
					{[
						...[...PaymentMethods].map((method, index) => {
							return {
								title: `Card ending in ${method.last4}`,
								card_type: method.card_type,
								id: method.id,
								icon: (
									<Image
										useBase
										src={
											method.card_type.trim() === 'visa'
												? '/img/visa-logo.svg'
												: '/img/visa-logo.svg'
										}
										alt='card'
										width={100}
										height={20}
										className='object-contain'
									/>
								),
							}
						}),
					].map((item, index) => {
						return (
							<button
								key={index}
								onClick={() => {
									setSelectedMethod(item.id)
								}}
								className='flex flex-row items-center w-full space-x-3 '
							>
								<div
									className={`self-start flex items-center justify-center w-5 h-5 rounded-full ${
										selectedMethod === item.id
											? 'bg-primary'
											: 'border-2 border-gray-300 cursor-pointer'
									}`}
								>
									{selectedMethod === item.id ? (
										<Check size={12} color={DDGColors.primaryLight} />
									) : (
										<></>
									)}
								</div>
								<div className='flex-row  flex items-center justify-between flex-1  border-opacity-40 border-b pb-3 border-[#D6D6D6]'>
									<div className='flex flex-col items-start flex-1 '>
										<p className='text-xs font-semibold text-gray900 '>
											{item.title}
										</p>
									</div>
									<div className=''>{item.icon}</div>
								</div>
							</button>
						)
					})}
					<button
						onClick={() => {}}
						className='flex flex-row items-center w-full space-x-3 '
					>
						<div className='items-center flex justify-center rounded-full p-1.5 bg-primaryLight'>
							<Plus size={12} color={DDGColors.primary} />
						</div>
						<div className='flex flex-row items-center justify-between flex-1 '>
							<div className='flex flex-col items-start flex-1 '>
								<p className='text-xs font-semibold text-gray900 '>
									Add new card
								</p>
							</div>
						</div>
					</button>
				</div>

				{ guests.length > 0 && <div>
					<p className='pt-5 pb-2 font-bold text-black '>Add Guests</p>
					<div className='space-y-5 '>
						{guests.length > 0 && guests.map((item, i) => {
							return (
								<div className='flex items-start gap-3 '>
									<div className='w-full space-y-3 '>
										<div>
											<input
												value={item.name}
												onChange={(e) => handleSetGuests(i, {name: e.target.value})}
												className='w-full border border-[#D6D6D680] text-sm px-2 hover:border-primary py-3 rounded-lg'
												type='text'
												placeholder='Full name'
											/>
										</div>
										<div className='relative '>
											<input
												className=' w-full pl-[105px] sm:pl-[120px] border border-[#D6D6D680] text-sm px-2 hover:border-primary py-3 rounded-lg'
												value={item.phoneNumber}
												onChange={(e) => handleSetGuests(i, {phoneNumber: e.target.value})}
												type='phone'
												placeholder=' Phone number'
											/>
											<div className='absolute top-0 bottom-0 left-0 px-3 bg-white border border-gray-300 rounded-l-lg hover:border-primary'>
												<CountryDropdown onChange={() => null}  value={item.countryCode ?? null} />
											</div>
										</div>
									</div>
									<button 
										className='w-auto mt-3 shrink-0'
										onClick={() => {
											setGuests((prevItems) => {
												const newArr = prevItems.filter((_, index) => index !== i)
												return newArr
											})
										}}
									>
										<X className=' text-[#667085]' size={20} />
									</button>
								</div>
							)
						})}
					</div>
					<button 
						className=' gap-2.5 flex items-center text-[#667085] mt-4'
						onClick={() => {
							setGuests((prevGuests) => ([...prevGuests, 
								{
									name: '', 
									phoneNumber: '', 
									countryCode: {
										code: 'GH',
										label: 'Ghana',
										phone: '+233',
										icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Flag_of_Ghana.svg/800px-Flag_of_Ghana.svg.png',
									}
								}
							]))
						}}
					>
						<UserPlus size={18} className='' />
						Add another
					</button>
				</div>}
			</div>
			<div
				className={`fixed bottom-0 pb-6
px-4 pt-3 
w-full  text-dark  border-t-2 border-gray-50 bg-white`}
			>
				<div className='flex flex-col gap-3 '>
					{/* <div className='w-1/2 '>
						<p className='text-sm font-bold text-primary'>
							{formatCurrency(
								classCount * wellnessClass.price -
									discountAmount -
									classCount *
										wellnessClass.price *
										(promoCodeData
											? promoCodeData?.perk.perk_amount / 100
											: 0)
							)}
						</p>
						<p className='text-xs font-bold '>
							{convertDateToString(
								new Date(activeClassBooking?.date ?? 0),
								true
							)}
						</p>
						<p className='text-[10px] text-gray-400 font-light'>
							Free cancellation*
						</p>
					</div> */}
					{guests.length <= 0 && <div className='w-full '>
						<button onClick={() => {
							setGuests((prevGuests) => ([...prevGuests, 
								{
									name: '', 
									phoneNumber: '', 
									countryCode: {
										code: 'GH',
										label: 'Ghana',
										phone: '+233',
										icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Flag_of_Ghana.svg/800px-Flag_of_Ghana.svg.png',
									}
								}
							]))
						}} className=' bg-[#EFEFEF] w-full py-3 rounded-md flex items-center justify-center text-sm font-medium gap-2 text-black'>
							<UserPlus size={16} className='' />
							Gift a Guest
						</button>
					</div>}

					{guests.length > 0 && <div className='flex items-center gap-2 '>
                        <button
                          onClick={() => setIncludeSelfToGuestOrder(!includeSelfToGuestOrder)}
                          className={`w-4 h-4 flex items-center justify-center rounded transition-colors duration-200
                                        ${
                                          includeSelfToGuestOrder
                                            ? 'bg-primary text-white'
                                            : 'bg-transparent text-transparent border border-primary'
                                        }`}
                        >
                          <Check size={12} strokeWidth={3} />
                        </button>
                        <p className='text-sm '>Pay for myself and for guests</p>
                    </div>}

					<div className='w-full'>
						<button
							className={`flex items-center justify-center w-full py-3 rounded-md  ${
								activeClassBooking ? 'bg-primary' : 'bg-gray-300'
							}`}
							disabled={loading}
							onClick={() => {
								continueFunc()
							}}
						>
							{loading ? (
								<RotatingLines width='20' strokeColor={DDGColors.gainsboro} />
							) : (
								<p className='text-sm font-semibold text-white'>Continue</p>
							)}
						</button>
					</div>
				</div>
			</div>
		</div>
	)
}

export default ClassStepBooking
